import { Vec3 } from "@/src/utils/vector";
import { Phase } from "./Walkthrough";
import { commentary, IWalkthroughArgs, setInitialCamera } from "./WalkthroughTools";

export function walkthrough08_Transformer(args: IWalkthroughArgs) {
    let { walkthrough: wt, state } = args;

    if (wt.phase !== Phase.Input_Detail_Transformer) {
        return;
    }

    setInitialCamera(state, new Vec3(-135.531, 0.000, -353.905), new Vec3(291.100, 13.600, 5.706));

    let c0 = commentary(wt, null, 0)`至此，一个完整的 Transformer 模块计算结束！

GPT 的主体由多个这样的模块堆叠组成。前一个模块的输出是下一个模块的输入，残差路径贯穿其中。

很难精确概括每层学到了什么，但可以形成大致理解：较早的层通常处理较基础的特征与模式，较后的层逐渐形成更复杂的抽象和关联。

在语言任务中，早期层可能处理局部语法、句法和词语关联，后期层可能表达更复杂的语义、篇章结构与上下文关系。这是一种概括，并非每层固定分工。`;

}
